export default __webpack_public_path__ + "static/media/privacy-policy-kr-0.942fec5b.jpg";